import styled from 'styled-components'

const H5 = styled.h5`
  font-size: 24px;
  font-weight: 500;
  line-height: 29px;
  margin: 0;
`

export default H5
